import { UserValue, UserCollector } from 'lib/actions/user'
import { CancelFunc, emptyCancel } from 'lib/cancel'
import { ListReturn, Status } from 'lib/rpc'
import { unaryListCollectSinglePage } from 'lib/rpcts'
import {
    SearchManagedUsersRequest,
    SearchManagedUsersResponse,
    SearchUsersRequest,
    SearchUsersResponse,
} from 'pbts/c1/api/user/v1/user'
import { UserSearchClient } from 'pbts/c1/api/user/v1/user.client'
import { Dispatch } from 'react'

export enum UserSearchAction {
    search = 'UserSearchAction.search',
    searchManagedUsers = 'UserSearchAction.searchManagedUsers',
}

export type SearchAction = {
    type: UserSearchAction.search
    payload: ListReturn<UserValue>
}

export type SearchManagedUsersAction = {
    type: UserSearchAction.searchManagedUsers
    payload: ListReturn<UserValue>
}

export type UserSearchActions = SearchAction | SearchManagedUsersAction

export const searchUsers = (
    dispatch: Dispatch<UserSearchActions>,
    client?: UserSearchClient,
    request?: SearchUsersRequest,
): CancelFunc => {
    if (!client || !request) {
        return emptyCancel
    }
    request.pageToken = ''
    const collector = new UserCollector()
    return unaryListCollectSinglePage<SearchUsersRequest, SearchUsersResponse>(
        request,
        client.search.bind(client),
        collector,
        (payload) => {
            switch (payload.status) {
                case Status.OK:
                    dispatch({
                        type: UserSearchAction.search,
                        payload: {
                            status: Status.OK,
                            items: collector.buffer(),
                            metadata: payload.metadata,
                        },
                    })
                    break
                default:
                    dispatch({
                        type: UserSearchAction.search,
                        payload,
                    })
            }
        },
    )
}

export const searchManagedUsers = (
    dispatch: Dispatch<UserSearchActions>,
    client?: UserSearchClient,
    request?: SearchManagedUsersRequest,
): CancelFunc => {
    if (!client || !request) {
        return emptyCancel
    }
    request.pageToken = ''
    const collector = new UserCollector()
    return unaryListCollectSinglePage<SearchManagedUsersRequest, SearchManagedUsersResponse>(
        request,
        client.searchManagedUsers.bind(client),
        collector,
        (payload) => {
            switch (payload.status) {
                case Status.OK:
                    dispatch({
                        type: UserSearchAction.searchManagedUsers,
                        payload: {
                            status: Status.OK,
                            items: collector.buffer(),
                            metadata: payload.metadata,
                        },
                    })
                    break
                default:
                    dispatch({
                        type: UserSearchAction.searchManagedUsers,
                        payload,
                    })
            }
        },
    )
}
